export default {"src":"/_next/static/media/hot.b763c788.gif","height":60,"width":60};